module.exports = __webpack_public_path__ + "img/icon-pin.8bf42a87.svg";